/** True when the configured topper is the Majestic product line. */
export function isMajesticTopper(slug?: string | null, slugEn?: string | null): boolean {
  const s = (slug || '').toLowerCase()
  const e = (slugEn || '').toLowerCase()
  return (
    s.includes('majestic') ||
    s.includes('majestisk') ||
    e === 'majestic' ||
    e.startsWith('majestic')
  )
}

/**
 * Material slots that receive the bed textile on Majestic toppers.
 * Standard Majestic FBX uses MajesticSlot_*; reclined/adjustable variants use BedMatSlot_1.
 */
export function isMajesticFabricMaterial(materialName: string | null | undefined): boolean {
  const name = (materialName || '').toLowerCase()
  if (!name) return false
  if (name.includes('majesticslot')) return true
  if (name === 'bedmatslot_1' || name.startsWith('bedmatslot_1')) return true
  return false
}
